import { render, staticRenderFns } from "./Gellery.vue?vue&type=template&id=75ad7492&scoped=true"
import script from "./Gellery.vue?vue&type=script&lang=js"
export * from "./Gellery.vue?vue&type=script&lang=js"
import style0 from "./Gellery.vue?vue&type=style&index=0&id=75ad7492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad7492",
  null
  
)

export default component.exports